import { type AssetType, assetTypes } from '@repo/types/asset';
import type { MessageAudience } from '@repo/types/messages';

import { getAppConfig } from '@/utils/window.utils';

export const isAddMessageEnabled = (assetType: AssetType, messageType: MessageAudience): boolean => {
    const config = getAppConfig();
    return Boolean(config.feature.messages?.[messageType]?.add?.enable) && assetType === assetTypes.order;
};

export const isEditMessageEnabled = (assetType: AssetType, messageType: MessageAudience): boolean => {
    const config = getAppConfig();
    const isEnabled =
        Boolean(config.feature.messages?.[messageType]?.edit?.enable) &&
        Boolean(config.feature.messages?.[messageType]?.read?.enable) &&
        assetType === assetTypes.order;

    return isEnabled;
};

export const isReadMessageEnabled = (assetType: AssetType, messageType: MessageAudience): boolean => {
    const config = getAppConfig();
    return Boolean(config.feature.messages?.[messageType]?.read?.enable) && assetType === assetTypes.order;
};
